export enum DataModes {
	Default,
	FollowUp,
	Copy,
	CopyWithRelations,
	CopyToType
}